export const LOADING_MESSAGES = [
    "מנתח נתונים, אנא המתן...",
    "סורק ומעבד את המסמכים...",
    "מחלץ את נתוני החשבונית...",
    "מבצע בדיקות התאמה בין החשבונית למסמכי השילוח...",
    "משווה שערי מטח עם נתוני בנק ישראל...",
    "תהליך העיבוד כמעט הושלם..."
  ];
  
  export const FILE_TYPES = {
    INVOICE: 'invoice',
    ADDITIONAL: 'additional'
  };
  
  export const ALLOWED_FILE_TYPES = /\.(pdf|doc|docx|png)$/i;
  
  export const ERROR_MESSAGES = {
    INVALID_FILE_TYPE: 'ניתן להעלות רק קבצי PDF, Word או PNG',
    UPLOAD_ERROR: 'אירעה שגיאה בעת עיבוד הקבצים. אנא נסה שוב.',
    UPLOAD_SUCCESS: 'הקבצים עובדו בהצלחה!'
  };